const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  img: {
    width: '32px',
    height: '32px',
  },
  paragraph: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  div: {
    width: '100%',
  },
  messageDiv: {
    display: 'flex',
    width: '480px',
    height: '22px',
    paddingTop: '4px',
    justifyContent: 'center',
  },
  imageDiv: {
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    display: 'grid',
    gap: '8px',
    width: '480px',
    maxWidth: '100%',
  },
  message: {
    display: 'flex',
    alignItems: 'center', // Vertically centers the items
    gap: '4px', // Adds space between the text and the icon (adjust as needed)
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 5 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
  },
  span: {
    marginRight: '4px',
  },

  link: {
    display: 'flex',
    alignItems: 'center', // Ensures the text and icon align properly
    textDecoration: 'none', // Optional: Remove underline if undesired
    color: 'var(--mcg-blue, #015FFB)',
  },

  inputDiv: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--Spacing-space-7, 12px)',
    alignSelf: 'stretch',
  },
  buttonDiv: {
    marginTop: '20px',
  },
  buttonHtml: {
    marginTop: '10px',
    alignSelf: 'flex-end',
  },
  inputDivHtml: {
    display: 'flex',
    flexDirection: 'column',
    width: '480px',
    maxWidth: '100%',
  },
  modeLabel: {
    margin: '4px 0 8px',
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '11px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  modeSwitch: {
    display: 'flex',
    padding: '4px',
    gap: '4px',
    marginBottom: '12px',
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
  },
  modeButton: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '10px 12px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '500',
  },
  modeButtonActive: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.12)',
  },
  modeInfo: {
    padding: '12px 16px',
    marginBottom: '12px',
    borderRadius: '8px',
  },
  modeInfoIsolated: {
    backgroundColor: '#EDF4FF',
  },
  modeInfoRaw: {
    backgroundColor: '#FFF6E5',
  },
  modeInfoText: {
    margin: 0,
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '150%',
    color: 'var(--mcg-dark, #002E47)',
  },
  modeInfoCode: {
    fontFamily: 'monospace',
    fontSize: '12px',
  },
  textAreaIsolated: {
    backgroundColor: '#FFFFFF !important',
    border: '1px solid var(--mcg-blue, #015FFB)',
  },
  textArea: {
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    maxHeight: '400px',
    overflowY: 'auto',
  },
})

export default styles
